import { useState, useEffect, useRef } from 'react'
import { useTranslation } from "react-i18next";
import '../translate';
import '../translate/translate';
import '../styles/ProfileModal.css';


function Detail({setIsDetailOpen}) {

    const [isDetailAll, setIsDetailAll] = useState(true)
    const [isDetailDeposits, setIsDetailDeposits] = useState(false)
    const [isDetailWithdraw, setIsDetailWithdraw] = useState(false)
    const { t } = useTranslation()
    const [details, setDetails] = useState([])
    const [detailAwaiting, setDetailAwaiting] = useState(false)
    const [detailCompleted, setDetailCompleted] = useState(false)
    const [detailCancelled, setDetailCancelled] = useState(false)
    const [detailEmpty, setDetailEmpty] = useState(false)
    const handleDetailClick = (detailType) => {
        setIsDetailAll(detailType === 'all');
        setIsDetailDeposits(detailType === 'deposits');
        setIsDetailWithdraw(detailType === 'withdrawals');
    };

    useEffect(() => {
        const getDetails = async () => {
        
            const token = localStorage.getItem('token');
            
            if (!token) {
                console.error("Token is missing!");
                return;
            }

            try {
                const response = await fetch(`${import.meta.env.VITE_API_URL}/get-details`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                    
                })
    
    
                if (response.ok) {
                    const data = await response.json();
                    if(data.details) {
                        setDetails(data.details)
                    }
                    

                    
                  }
            } catch (error) {
                console.error("Error fetching details:", error);

            }
          
    }
    getDetails()
    }, [])


    useEffect(() => {
        if(details.length > 0) {
            for (const item of details) {
                if (item.state === 'processing' || item.state === 'pending') {
                    if(!detailAwaiting) {
                        setDetailAwaiting(true)
                    }
                } else if (item.state === 'complated') {
                    if(!detailCompleted) {
                        setDetailCompleted(true)
                    }
                } else if (item.state === 'cancelled') {
                    if(!detailCancelled) {
                        setDetailCancelled(true)
                    }
                }
            }
        }

    }, [details])

    useEffect(() => {
        if(!detailAwaiting && !detailCompleted && !detailCancelled) {
            setDetailEmpty(true)
        }
    }, [detailAwaiting, detailCompleted, detailCancelled])


    const formatDate = (isoString) => {
        const date = new Date(isoString);
      
        // Опции для отображения даты
        const dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
        const formattedDate = date.toLocaleDateString('en-US', dateOptions);
      
        // Опции для отображения времени
        const timeOptions = { hour: '2-digit', minute: '2-digit', hour12: true };
        const formattedTime = date.toLocaleTimeString('en-US', timeOptions);
      
        return { formattedDate, formattedTime };
      };




    return (
        <div className={'profile-modal-wrapper'}>
            <div className={'profile-modal-container'}>
                <div className={'profile-modal-container-wrap'}>
                <img className={'profile-modal-close-button'} src="/assets/img/main/close_button.svg" alt="" onClick={() => setIsDetailOpen(false)}/>
                <div className={'profile-modal-title'}>
                    <span>{t("mp_detail")}</span>
                </div>
                <div className={'detail-navbar-wrapper'}>
                    <div className={`detail-navbar-wrapper-items first ${isDetailAll ? "active" : ""}`} onClick={() => handleDetailClick('all')}>{t("mp_all")}</div>
                    <div className={`detail-navbar-wrapper-items ${isDetailDeposits ? "active" : ""}`} onClick={() => handleDetailClick('deposits')}>{t("mp_deposit")}</div>
                    <div className={`detail-navbar-wrapper-items last ${isDetailWithdraw ? "active" : ""}`} onClick={() => handleDetailClick('withdrawals')}>{t("mp_withdraw")}</div>
                </div>





                {detailAwaiting && isDetailAll && <div className={'detail-awaiting-wrapper'}>
                    <div className={'detail-awaiting-title'}>
                        {t("mp_awaiting")}
                    </div>
                    {details.length > 0 ? details.map((part, index) => (
                        part.state === 'pending' || part.state === 'processing' ? 
                        <div className={'detail-awaiting-item'}>
                        <div className={'detail-awaiting-item-title'}>
                            <p>ID #{parseFloat(part.id) + parseFloat(import.meta.env.VITE_ID_ADD)}</p>
                            <p>{formatDate(part.createdAt).formattedDate} | {formatDate(part.createdAt).formattedTime}</p>
                        </div>
                        <div className={'detail-awaiting-item-body'}>
                            <p>{part.method.toUpperCase()}</p>
                            <div className={'detail-font-size-14'}>
                                {part.currency.toUpperCase()} {part.amount}
                                <img src="/assets/img/main/clock.svg" alt="" />
                            </div>
                        </div>
                    </div>  : ""

                        
                       
                    )) : ""}
                </div>}


                {detailAwaiting && (isDetailDeposits) && <div className={'detail-awaiting-wrapper'}>
                    <div className={'detail-awaiting-title'}>
                        {t("mp_awaiting")}
                    </div>
                    {details.length > 0 ? details.map((part, index) => (
                        part.type === 'deposit' && (part.state === 'pending' || part.state === 'processing') ? 
                        <div className={'detail-awaiting-item'}>
                        <div className={'detail-awaiting-item-title'}>
                            <p>ID #{parseFloat(part.id) + parseFloat(import.meta.env.VITE_ID_ADD)}</p>
                            <p>{formatDate(part.createdAt).formattedDate} | {formatDate(part.createdAt).formattedTime}</p>
                        </div>
                        <div className={'detail-awaiting-item-body'}>
                            <p>{part.method.toUpperCase()}</p>
                            <div className={'detail-font-size-14'}>
                                {part.currency.toUpperCase()} {part.amount}
                                <img src="/assets/img/main/clock.svg" alt="" />
                            </div>
                        </div>
                    </div>  : ""

                        
                       
                    )) : ""}
                </div>}

                {detailAwaiting && (isDetailWithdraw) && <div className={'detail-awaiting-wrapper'}>
                    <div className={'detail-awaiting-title'}>
                        {t("mp_awaiting")}
                    </div>
                    {details.length > 0 ? details.map((part, index) => (
                        part.type === 'withdraw' && (part.state === 'pending' || part.state === 'processing') ? 
                        <div className={'detail-awaiting-item'}>
                        <div className={'detail-awaiting-item-title'}>
                            <p>ID #{parseFloat(part.id) + parseFloat(import.meta.env.VITE_ID_ADD)}</p>
                            <p>{formatDate(part.createdAt).formattedDate} | {formatDate(part.createdAt).formattedTime}</p>
                        </div>
                        <div className={'detail-awaiting-item-body'}>
                            <p>{part.method.toUpperCase()}</p>
                            <div className={'detail-font-size-14'}>
                                {part.currency.toUpperCase()} {part.amount}
                                <img src="/assets/img/main/clock.svg" alt="" />
                            </div>
                        </div>
                    </div>  : ""

                        
                       
                    )) : ""}
                </div>}


                {detailCompleted && <div className={'detail-awaiting-wrapper'}>
                    <div className={'detail-awaiting-title'}>
                        {t("mp_completed")}
                    </div>
                    <div className={'detail-awaiting-item'}>
                        <div className={'detail-awaiting-item-title'}>
                            <p>ID #100042</p>
                            <p>April 5, 2025 | 10:15 PM</p>
                        </div>
                        <div className={'detail-awaiting-item-body'}>
                            <p>HUMO</p>
                            <div className={'detail-font-size-14 detail-color-green'}>
                                + UZS 325,000.00
                            </div>
                        </div>
                    </div>
                    <div className={'detail-awaiting-item'}>
                        <div className={'detail-awaiting-item-title'}>
                            <p>ID #100042</p>
                            <p>April 5, 2025 | 10:15 PM</p>
                        </div>
                        <div className={'detail-awaiting-item-body'}>
                            <p>HUMO</p>
                            <div className={'detail-font-size-14 detail-color-orange'}>
                                - UZS 325,000.00
                            </div>
                        </div>
                    </div>
                </div>}



                {detailCancelled && <div className={'detail-awaiting-wrapper'}>
                    <div className={'detail-awaiting-title'}>
                        {t("mp_canceled")}
                    </div>
                    {details.length > 0 ? details.map((part, index) => (
                        part.state === 'cancelled' ? 
                        <div className={'detail-awaiting-item'}>
                        <div className={'detail-awaiting-item-title'}>
                            <p>ID #{parseFloat(part.id) + parseFloat(import.meta.env.VITE_ID_ADD)}</p>
                            <p>{formatDate(part.createdAt).formattedDate} | {formatDate(part.createdAt).formattedTime}</p>
                        </div>
                        <div className={'detail-awaiting-item-body'}>
                            <p>{part.method.toUpperCase()}</p>
                            <div className={'detail-font-size-14'}>
                                {part.currency.toUpperCase()} {part.amount}
                                <img src="/assets/img/main/ban.svg" alt="" />
                            </div>
                        </div>
                    </div>  
                    : ""

                        
                       
                    )) : ""}
                    {/* <div className={'detail-awaiting-item'}>
                        <div className={'detail-awaiting-item-title'}>
                            <p>ID #100042</p>
                            <p>April 5, 2025 | 10:15 PM</p>
                        </div>
                        <div className={'detail-awaiting-item-body'}>
                            <p>HUMO</p>
                            <div className={'detail-font-size-14'}>
                                UZS 325,000.00
                                <img src="/assets/img/main/ban.svg" alt="" />
                            </div>
                        </div>
                    </div> */}
                </div>}
                {/* {detailEmpty && <div className={'detail-empty'}>
                        <div>{t("mp_empty_detail")}</div>
                </div>} */}

                </div>
            </div>
        </div>
    )
}

export default Detail;